module.exports = __webpack_public_path__ + "img/7.ed5f39c7.png";